export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12 text-center">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            投稿与咨询
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-8 leading-relaxed">
            如果您有优质内容资源希望合作，或对91麻豆免费视频网站有任何意见与建议，欢迎通过以下方式与我们取得联系。我们珍视每一位用户的反馈，期待与您共同打造更优质的高清视频在线观看平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 px-6 py-3 bg-background-100 rounded-xl border border-background-200/70 cursor-pointer hover:border-primary-300/50 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">contact@91madou.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3 px-6 py-3 bg-background-100 rounded-xl border border-background-200/70 cursor-pointer hover:border-primary-300/50 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-accent-500 text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">官方微信</div>
                <div className="text-sm font-medium text-foreground-800">91麻豆视频</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}